export default __webpack_public_path__ + "static/media/hht2_img_logo.9d4bb75e.png";